import { useContext } from "react";
import { AlertContext } from "store/AlertContextPovider";

const useAlert = () => useContext(AlertContext)

export default useAlert;
